// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer"; // Foundation
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
// import * as React from "react"; // Valtech Custom Code
import { connect } from "react-redux";
import { css } from "styled-components";

/* Valtech Custom Code */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { useContext, useEffect } from "react";
/* Valtech Custom Code */

/* Foundation - Start */
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
/* Foundation - End */

// bunzl custom code
enum fields {
    orientation = "orientation",
}
export interface ProductDetailsViewStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnInnerContainer?: GridContainerProps;
    topGridItem?: GridItemProps;
    middleGridItem?: GridItemProps;
    middleGridItemHidden?: HiddenProps;
    bottomGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridItemHidden?: HiddenProps;
    // Valtech Custom Code
    spacerColumnGridItem?: GridItemProps;
    mobileHeading?: InjectableCss;
    desktopHeading?: InjectableCss;
}

export const viewStyles: ProductDetailsViewStyles = {
    container: {
        css: css`
            ${GridOffset} {
                justify-content: space-between;
            }
            width: 100%;
            height: 100%;
        `,
    },
    leftColumnGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            // bunzl custom code removed overflow hidden
            width: 100%;
            // bunzl custom code - fixed small bug on mobile
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            height: 100%;
                        `,
                    ],
                    mediaOptions.min,
                )}

            // bunzl custom code - needed to properly display overlay badges
            position: relative;
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: ${pxToRem(20)};
                        `,
                        null,
                        css`
                            padding: ${pxToRem(15)};
                        `,
                    ],
                    mediaOptions.min,
                )}

            > * {
                display: flex;
                align-items: flex-start;

                gap: 0.5rem;
                ${({ theme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                flex-direction: column-reverse;
                            `,
                            css`
                                flex-direction: row;
                            `,
                        ],
                        mediaOptions.min,
                    )}
            }
        `,
    },
    topGridItem: { width: 12 },
    middleGridItem: { width: [12, 12, 0, 0, 0] },
    middleGridItemHidden: {
        above: "sm",
        css: css`
            width: 100%;
        `,
    },
    bottomGridItem: { width: 12 },
    rightColumnGridItem: {
        width: [12, 12, 5, 5, 5],
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            margin-left: 8.75em;

            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: ${pxToRem(20)};
                        `,
                        null,
                        css`
                            padding: ${pxToRem(15)};
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    rightColumnGridItemHidden: {
        below: "md",
    },
};

const styles = viewStyles;
// bunzl custom code --->
interface OwnProps extends WidgetProps {
    fields: {
        [fields.orientation]: "vertical" | "horizontal";
    };
}
// <--- bunzl custom code
const ProductDetailsView: React.FC<OwnProps> = props => {
    /* Valtech Custom Code */

    // bunzl custom code --->
    const orientation = props.fields.orientation;
    const isVertical = orientation === "vertical";

    const leftColumnGridItemStyles = isVertical
        ? {
              ...styles.leftColumnGridItem,

              css: css`
                  ${styles.leftColumnGridItem?.css}
                  > * {
                      flex-direction: column;
                      // bunzl custom code
                      height: auto !important; // being overwritten by the child component and needs higher specificity
                  }
              `,
          }
        : styles.leftColumnGridItem;

    // <--- bunzl custom code
    const productId = useContext(ProductContext).product.id;
    const trackViewItem = ga.use.trackViewItem();

    useEffect(() => {
        trackViewItem();
        // bunzl custom code fixed dependency array
    }, [productId, trackViewItem]);

    return (
        // Valtech Custom Code --->
        <GridContainer {...styles.container} data-test-selector="productDetailsView_container" /* Bunzl Custom Code */>
            <GridItem
                {...leftColumnGridItemStyles}
                data-test-selector="productDetails_leftColumn" /* Bunzl Custom Code */
            >
                <Zone
                    fullHeight
                    contentId={props.id}
                    zoneName="LeftZone"
                    data-test-selector="productDetailsView_leftZone"
                />
            </GridItem>
            <GridItem {...styles.rightColumnGridItem} data-test-selector="productDetails_rightColumn">
                <Zone
                    contentId={props.id}
                    zoneName="RightZone"
                    data-test-selector="productDetailsView_rightZone" /* Bunzl Custom Code */
                />
            </GridItem>
        </GridContainer>
        // <--- Valtech Custom Code
    );
};

const widgetModule: WidgetModule = {
    component: connect()(ProductDetailsView),
    definition: {
        displayName: "View",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        // bunzl custom code --->
        fieldDefinitions: [
            {
                name: fields.orientation,
                displayName: "Orientation",
                editorTemplate: "RadioButtonsField",
                defaultValue: "horizontal",
                fieldType: "General",
                options: [
                    {
                        displayName: "Vertical",
                        value: "vertical",
                    },
                    {
                        displayName: "Horizontal",
                        value: "horizontal",
                    },
                ],
                sortOrder: 0,
            },
        ],
        // <--- bunzl custom code
    },
};

export default widgetModule;
